'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageRail = function PageRail(_ref) {
  var children = _ref.children,
      side = _ref.side;
  return _react2.default.createElement(
    'div',
    { className: 'quiver-page-rail--' + side },
    children
  );
};

PageRail.propTypes = {
  children: _propTypes2.default.node,
  side: _propTypes2.default.string.isRequired
};

exports.default = PageRail;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/PageRail/PageRail.js
// module id = 625
// module chunks = 11